const initialState = {
    anchor: 'left',
    estado: [],
    open: false,
    id: '',
    nome: '',
    uf: '',
    ibge: '',
    data_exclusao: '',
    usuario_exclusao: ''
};

export function estado(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_ESTADO':
            return {
                ...state,
                estado: action.estado
            };
        case 'ESTADO_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                uf: action.uf,
                ibge: action.ibge,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao
            };
        case "ESTADO_UPDATED":
            return state;      
        default:
            return state
    }
}
